// ——————————————————————————————————————————————————
// TextScramble
// ——————————————————————————————————————————————————

class TextScramble {
  constructor(el) {
    this.el = el
    this.chars = '10'
    this.update = this.update.bind(this)
  }
  setText(newText) {
    const oldText = this.el.innerText
    const length = Math.max(oldText.length, newText.length)
    const promise = new Promise((resolve) => this.resolve = resolve)
    this.queue = []
    for (let i = 0; i < length; i++) {
      const from = oldText[i] || ''
      const to = newText[i] || ''
      const start = Math.floor(Math.random() * 40)
      const end = start + Math.floor(Math.random() * 40)
      this.queue.push({ from, to, start, end })
    }
    cancelAnimationFrame(this.frameRequest)
    this.frame = 0
    this.update()
    return promise
  }
  update() {
    let output = ''
    let complete = 0
    for (let i = 0, n = this.queue.length; i < n; i++) {
      let { from, to, start, end, char } = this.queue[i]
      if (this.frame >= end) {
        complete++
        output += to
      } else if (this.frame >= start) {
        if (!char || Math.random() < 0.28) {
          char = this.randomChar()
          this.queue[i].char = char
        }
        output += `<span class="dud">${char}</span>`
      } else {
        output += from
      }
    }
    this.el.innerHTML = output
    if (complete === this.queue.length) {
      this.resolve()
    } else {
      this.frameRequest = requestAnimationFrame(this.update)
      this.frame++
    }
  }
  randomChar() {
    return this.chars[Math.floor(Math.random() * this.chars.length)]
  }
}

export default {

  init: () => {
    
    $('[data-scramble]')
      .each((index, el) => {

        const phrases = $(el).data('scramble').split('|')
        const fx = new TextScramble(el)
    
        let counter = 0
        const next = () => {
          fx.setText(phrases[counter]).then(() => {
            setTimeout(next, $(el).data('interval') || 800)
          })
          counter = (counter + 1) % phrases.length
        }
        
        next()    

        
      })
      
    $('[data-words]')
      .attr('data-words', function(i, data) {
        let 
          $self = $(this),
          words = data.split('|'),
          numWords = words.length,
          index = 0; 

        // create individual spans for words

        words.forEach(word => {
          $self.append($('<span/>',{ text: word }).css({ 
            position: 'absolute',
            whiteSpace: 'nowrap',
            transitionDuration: '0.35s', 
          }))
        })

        // collect word spans and hide

        words = $self.find('span').css({ opacity: 0 });

        // run loop

        (function loop() {
          $self.css({ width: words.eq( index ).width() })
          words.css({ opacity: 0, transform: 'translateX(-20px)', transitionDelay: '0s' }).eq(index).css({ opacity: 1, transform: 'translateX(0)', transitionDelay: '0.25s' })
          setTimeout(loop, $self.data('interval') || 3000)
          index = ++index % numWords
        }());

        // style container

        $self.css({
          verticalAlign: 'top',
          position: 'static',
          textAlign: 'left',
          transition: 'width 0.65s cubic-bezier(0.785, 0.135, 0.150, 0.860)',
          display: 'inline-block',
        })
        
      });

  }

}